import { render, staticRenderFns } from "./TheDesktopNavigation.vue?vue&type=template&id=11fd7fad&scoped=true"
import script from "./TheDesktopNavigation.js?vue&type=script&lang=js&external"
export * from "./TheDesktopNavigation.js?vue&type=script&lang=js&external"
import style0 from "./TheDesktopNavigation.scss?vue&type=style&index=0&id=11fd7fad&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd7fad",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DesktopNavigationEntry: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheDesktopNavigation/DesktopNavigationEntry/DesktopNavigationEntry.vue').default})
